import * as React from 'react';

function QuickActionsIcon({ width = 16, height = 16, color = '#545454', ...props }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 24 24'
			fill='none'
			{...props}
		>
			<path
				d='M4 14.091a1 1 0 01-.78-1.63l9.9-10.2a.5.5 0 01.86.46l-1.92 6.02a1 1 0 00.94 1.35h7a1 1 0 01.78 1.63l-9.9 10.2a.5.5 0 01-.86-.46l1.92-6.02a1 1 0 00-.94-1.35H4z'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default QuickActionsIcon;
